'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateFeatures = undefined;

var _lensPath = require('ramda/src/lensPath');

var _lensPath2 = _interopRequireDefault(_lensPath);

var _set = require('ramda/src/set');

var _set2 = _interopRequireDefault(_set);

var _view = require('ramda/src/view');

var _view2 = _interopRequireDefault(_view);

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nameLens = (0, _lensPath2.default)(['name']);
var isActiveLens = (0, _lensPath2.default)(['isActive']);

var getName = (0, _view2.default)(nameLens);
var setIsActive = (0, _set2.default)(isActiveLens);

var activateFeatures = exports.activateFeatures = function activateFeatures(featureNamesToEnable) {
  return (0, _map2.default)(function (feature) {
    return featureNamesToEnable.includes(getName(feature)) ? setIsActive(true, feature) : feature;
  });
};